import { UnitType } from './unit-type.enum';

export class ChurchUnit {
    unitNumber: string;
    name: string;
    unitType?: UnitType;
}
